<forge-card class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
      @if (isLoaded) {
        <truncate-text class="forge-typography--subheading1" [allowHtml]="true" fxFlex="100" [mainText]="ChartSubtitle">
        </truncate-text>
      }
    </div>

    <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
      <forge-tooltip>Chart settings</forge-tooltip>
      <forge-icon name="settings"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div class="metadata-padding" fxLayout="column">
    @if (hasGroups) {
      <div fxFlex="100" fxLayout="row" [formGroup]="formGroup" class="tt-margin--bottom">
        <lgd-select fxFlex="100" controlName="groupBy" label="Department" [options]="groups">
        </lgd-select>
      </div>
    }

    <div>
      @if (!isLoaded) {
        <busy-indicator [chart]="true"></busy-indicator>
      }

      @if (isLoaded) {
        @if (chartHasData) {
          <account-detail-card fxFlex [chartHasData]="chartHasData" [shareable]="true" [totals]="ChartData">
          </account-detail-card>
        }
        @if (!chartHasData) {
          <div>
            Not enough data to display breakdown
          </div>
        }
      }
    </div>
  </div>
</forge-card>